var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 271,
    viewBox: "0 0 256 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246 0H10C4.47715 0 0 4.47715 0 9.99999V261C0 266.523 4.47715 271 10 271H246C251.523 271 256 266.523 256 261V10C256 4.47715 251.523 0 246 0Z",
    fill: "#93D6E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.687 27.3867H42.313C36.065 27.3867 31 32.4155 31 38.6189V228.768C31 234.971 36.065 240 42.313 240H212.687C218.935 240 224 234.971 224 228.768V38.6189C224 32.4155 218.935 27.3867 212.687 27.3867Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.049 45.5542L118.159 39.3745",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.298 87.6747L118 48.6821",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.336 81.645L141.218 81.7031C143.626 81.748 145.951 80.8534 147.684 79.2154C149.417 77.5774 150.416 75.3296 150.462 72.9646V72.9646C150.499 70.6015 149.581 68.3178 147.91 66.6126C146.239 64.9073 143.95 63.9194 141.544 63.8654L114.865 63.3074C112.459 63.2534 110.17 62.266 108.499 60.5607C106.828 58.8555 105.91 56.5714 105.947 54.2084C105.993 51.8434 106.992 49.5954 108.725 47.9574C110.458 46.3195 112.783 45.4249 115.191 45.4699L118.073 45.5283L150.961 46.1928",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.413 81.2295L135.15 81.5806",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.452 80.9818L114.221 81.1648",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.976 45.9688L139.086 39.8018",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.226 88.0899L138.921 49.1035",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4233 188.853H210.725",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1709 100.598H161.709L122.131 132.014V188.852H59.5927V132.014L99.1709 100.598Z",
    fill: "#DDDDDD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M156.603 144.725H152.519V188.852H156.603V144.725Z",
    fill: "#DDDDDD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.28 144.725H185.196V167.792H189.28V144.725Z",
    fill: "#DDDDDD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.905 188.852V132.014L161.951 100.598L200.513 131.534V188.852H122.905Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5927 188.852V132.014L99.1709 100.598H161.709L122.131 132.014V188.852H59.5927Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5927 130.685H122.905",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1217 146.731H68.7831V167.792H85.1217V146.731Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.735 146.731H97.3756V167.792H114.735V146.731Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M156.603 144.725H134.138V188.852H156.603V144.725Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.28 144.725H166.815V167.792H189.28V144.725Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M169.878 131.656V121.952C169.878 120.012 169.071 118.152 167.633 116.781C166.196 115.409 164.247 114.639 162.214 114.639V114.639C161.208 114.639 160.212 114.828 159.283 115.195C158.353 115.563 157.509 116.102 156.798 116.781C156.088 117.461 155.524 118.267 155.14 119.154C154.756 120.041 154.559 120.992 154.561 121.952V131.688L169.878 131.656Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M190.302 214.928H64.6984",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.3977d8a0e6be43ebf71a34a0742f0d81.svg";
export { ForwardRef as ReactComponent };